'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _displayTools = require('../../utils/display-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Table = function (_React$Component) {
	_inherits(Table, _React$Component);

	function Table(props) {
		_classCallCheck(this, Table);

		var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

		_this.state = {};
		_this.ignoreColumns = ["brand_id", "brand_slug", "store_id", "store_slug", "region_id", "region_slug"];
		return _this;
	}

	_createClass(Table, [{
		key: 'render',
		value: function render() {
			var keys, data;
			if (this.props.data[0]) {
				data = this.props.data;
				keys = Object.keys(data[0]);
			} else {
				data = [];
				keys = [];
			}

			return _react2.default.createElement(
				'div',
				{ className: 'table' },
				_react2.default.createElement(
					'table',
					{ className: 'report-table' },
					this.renderHead(keys),
					this.renderBody(data, keys)
				)
			);
		}
	}, {
		key: 'renderHead',
		value: function renderHead(keys) {
			var _this2 = this;

			return _react2.default.createElement(
				'thead',
				null,
				_react2.default.createElement(
					'tr',
					null,
					keys.map(function (key, i) {

						if (_this2.ignoreColumns.indexOf(key) >= 0) return null;

						return _react2.default.createElement(
							'th',
							{ key: i, className: (0, _classnames2.default)('cell-format-' + key) },
							(0, _displayTools.formatTitle)(key)
						);
					})
				)
			);
		}
	}, {
		key: 'renderBody',
		value: function renderBody(data, keys) {
			var _this3 = this;

			return _react2.default.createElement(
				'tbody',
				null,
				data.map(function (row, i) {
					return _react2.default.createElement(
						'tr',
						{ key: i },
						keys.map(function (key, j) {

							if (_this3.ignoreColumns.indexOf(key) >= 0) return null;

							return _react2.default.createElement(
								'td',
								{ key: j, className: (0, _classnames2.default)('cell-format-' + key) },
								(0, _displayTools.formatValue)(row[key], key, row)
							);
						})
					);
				})
			);
		}
	}]);

	return Table;
}(_react2.default.Component);

exports.default = Table;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/charts/Table.js
// module id = 560
// module chunks = 0